import { Component, OnInit, AfterContentInit, ViewChild, EventEmitter, Output, OnDestroy, signal, } from '@angular/core';
import { MatBottomSheet } from '@angular/material/bottom-sheet';
import { MeasurePanelComponent } from './measure-panel/measure-panel.component';
import { BrowserSnifferService } from '../../services/browser-sniffer.service';
import { ToggleEventNameType, ToggleEventService } from '../../services/toggle-event.service';
import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { TranslateModule } from '@ngx-translate/core';
import { BackEventService } from '@tt-lib/services/back-event.service';

@Component({
  selector: 'tt-measure',
  imports: [
    CommonModule,
    MatButtonModule,
    MatIconModule,
    MatTooltipModule,
    TranslateModule
  ],
  templateUrl: './measure.component.html',
  styleUrls: ['./measure.component.scss'],
  standalone: true
})
export class MeasureComponent implements OnInit, AfterContentInit, OnDestroy {
  public isOpen = signal(false);
  @ViewChild('measurePanel') measurePanel: MeasurePanelComponent;

  constructor(
    //private bottomSheetRef: MatBottomSheetRef<MeasurePanelComponent>,
    public browserSniffer: BrowserSnifferService,
    private bottomSheet: MatBottomSheet,
    private toggleEventService: ToggleEventService,
    private backEventService: BackEventService
  ) { }

  //!
  ngOnInit() {
    // setTimeout(() => {
    //   this.togglePanel(null)
    // }, 1500)
  }

  ngOnDestroy(): void {
  }

  togglePanel(event) {
    this.isOpen() ? this.closePanel(event) : this.openPanel(event);
  }

  openPanel(event) {
    let sheetRef = this.bottomSheet.open(MeasurePanelComponent, {
      data: {
        // panelTemplate: 'sjappiTemplateRef',
        //title: "A title to test the title"
      },
      hasBackdrop: false,
      panelClass: 'measure-bottomsheet',
      // disableClose: true
    });
    //! unsub
    sheetRef.afterDismissed().subscribe((data) => {
      this.isOpen.set(false);
      this.toggleEventService.toggleEvent({
        eventName: ToggleEventNameType.CLOSE,
        forwardedFor: 'measure',
      });

    });
    this.isOpen.set(true);
    this.toggleEventService.toggleEvent({
      eventName: ToggleEventNameType.OPEN,
      forwardedFor: 'measure',
    });

    this.backEventService.registerOpenedWindow({windowName: 'MeasurePanelComponent', isAutoCloseableWindow: true});
  }

  closePanel(event) {
    this.bottomSheet.dismiss();
    event.preventDefault();
  }
  ngAfterContentInit() { }
}
